import { onAuthStateChanged, signOut } from "firebase/auth";
import { ref, watch, computed, reactive } from "vue";
import auth from "./firebaseAuth";
import api from "@/composables/api";
import { useReviewers, useUser } from "@/stores";

export default () => {
  const count = ref(0);
  const double = computed(() => count.value * 2);
  const increment = () => count.value++;

  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    const topPosition = element.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: topPosition,
      behavior: "smooth",
    });
  };

  ////////////////////////
  // Table Refresh
  ////////////////////////
  // Re-fetches the current page, keeping the active filter and page size
  const handleTableRefresh = () => {
    const reviewersStore = useReviewers();
    const userStore = useUser();

    if (userStore.currentPage < 1) {
      userStore.currentPage = 1;
    }

    return reviewersStore.refreshCurrentPage();
  };

  return {
    count,
    double,
    increment,
    scrollToElement,
    handleTableRefresh,
  };
};
